module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "sub-header"
  }, [_c('div', {
    staticClass: "width-wrapper relative"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Отчеты и отправка")]), _vm._v(" "), _c('div', {
    staticClass: "header__save"
  }, [_c('a', {
    staticClass: "button button--inverse",
    attrs: {
      "href": "/api/reports/products_pharmacy_global"
    }
  }, [_vm._v("Скачать текущий отчет")]), _vm._v(" "), (_vm.$store.state.user.role == 'HM') ? _c('span', [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('add/')
      }
    }
  }, [_vm._v("Отправить данные")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "reports-list"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "reports-list-body"
  }, _vm._l((_vm.pharmacies), function(pharmacy) {
    return _c('div', {
      staticClass: "report-item-line"
    }, [_c('div', {
      staticClass: "report-item report-item__pharmacy"
    }, [_vm._v(_vm._s(pharmacy.title))]), _vm._v(" "), _c('div', {
      staticClass: "report-item report-item__date"
    }, [_vm._v(_vm._s(pharmacy.version !== null ? pharmacy.version.title : ''))]), _vm._v(" "), _c('div', {
      staticClass: "report-item report-item__groups"
    }, [_vm._v(_vm._s(pharmacy.version !== null ? pharmacy.version.clusterCount : ''))]), _vm._v(" "), _c('div', {
      staticClass: "report-item report-item__facings"
    }, [_vm._v(_vm._s(pharmacy.version !== null ? pharmacy.version.facingCount : ''))]), _vm._v(" "), _c('div', {
      staticClass: "report-item report-item__report"
    }, [_vm._v(_vm._s(pharmacy.version !== null ? _vm.statuses[pharmacy.version.status] : ''))]), _vm._v(" "), _c('div', {
      staticClass: "report-item report-item__report"
    })])
  }), 0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reports-list-head"
  }, [_c('div', {
    staticClass: "report-item report-item--head report-item__pharmacy report-item__pharmacy--head"
  }, [_vm._v("Аптека")]), _vm._v(" "), _c('div', {
    staticClass: "report-item report-item--head report-item__date report-item__date--head"
  }, [_vm._v("Дата "), _c('br'), _vm._v("отправки")]), _vm._v(" "), _c('div', {
    staticClass: "report-item report-item--head report-item__groups report-item__groups--head"
  }, [_vm._v("Товарных "), _c('br'), _vm._v("групп")]), _vm._v(" "), _c('div', {
    staticClass: "report-item report-item--head report-item__facings report-item__facings--head"
  }, [_vm._v("Показов")]), _vm._v(" "), _c('div', {
    staticClass: "report-item report-item--head report-item__report report-item__report--head"
  }, [_vm._v("Статус")]), _vm._v(" "), _c('div', {
    staticClass: "report-item report-item--head report-item__report report-item__report--head"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c3cb1ad","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/Versions.vue
// module id = 243
// module chunks = 1